angular.module("vgresiduos").controller("CustomReportEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `bi/relatorios-personalizados/${$stateParams.reportId}`);
		};
	}
]);
